(function () {
  "use strict";

  const MOBILE_MAX_WIDTH = 768;
  const MODE_B_BODY_CLASS = "teeinblue-platform-product-enabled";
  const PREVIEW_SELECTOR = ".tee-btn--preview";
  const PRODUCT_FORM_SELECTOR = "form.main-product-form.tee-form-wrapper";
  const ACTION_CONTAINER_SELECTOR = ".pdp-action-container.yv-checkout-btn";
  const PRODUCT_SUBMIT_SELECTOR = "button[id^=\"ProductSubmitButton-\"].Sd_addProduct.add_to_cart";

  let scheduled = false;
  let observedForm = null;
  let formObserver = null;
  let movedPreview = null;

  function isModeBMobile() {
    return Boolean(
      document.body &&
        document.body.classList.contains("teeinblue-enabled") &&
        document.body.classList.contains(MODE_B_BODY_CLASS) &&
        window.innerWidth <= MOBILE_MAX_WIDTH
    );
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function getProductForm() {
    return document.querySelector(PRODUCT_FORM_SELECTOR);
  }

  function getVisibleActionContainer(form) {
    if (!form) {
      return null;
    }

    return Array.from(form.querySelectorAll(ACTION_CONTAINER_SELECTOR)).find(
      function (container) {
        const submitButton = container.querySelector(PRODUCT_SUBMIT_SELECTOR);
        // KOOLEZT: the page's Add to cart is hidden on purpose (the Preview window has its own), so only the box
        // itself needs to be visible for Preview to move into it.
        return isVisible(container) && Boolean(submitButton);
      }
    );
  }

  function restorePreview() {
    if (!movedPreview) {
      return;
    }

    const { preview, parent, nextSibling } = movedPreview;
    if (preview.isConnected && parent.isConnected && preview.parentElement !== parent) {
      parent.insertBefore(
        preview,
        nextSibling && nextSibling.parentNode === parent ? nextSibling : null
      );
    }

    movedPreview = null;
  }

  function observeProductForm(form) {
    if (form === observedForm) {
      return;
    }

    if (formObserver) {
      formObserver.disconnect();
    }

    observedForm = form;
    if (!form) {
      return;
    }

    formObserver = new MutationObserver(function (records) {
      const hasRelevantMutation = records.some(function (record) {
        return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(
          function (node) {
            if (node.nodeType !== Node.ELEMENT_NODE) {
              return false;
            }

            const element = node;
            return (
              element.matches(PREVIEW_SELECTOR) ||
              element.matches(ACTION_CONTAINER_SELECTOR) ||
              element.querySelector(PREVIEW_SELECTOR) ||
              element.querySelector(ACTION_CONTAINER_SELECTOR)
            );
          }
        );
      });

      if (hasRelevantMutation) {
        scheduleReconcile();
      }
    });
    formObserver.observe(form, { childList: true, subtree: true });
  }

  function reconcilePreview() {
    scheduled = false;

    const form = getProductForm();
    observeProductForm(form);

    if (!isModeBMobile()) {
      restorePreview();
      return;
    }

    const preview = form && form.querySelector(PREVIEW_SELECTOR);
    const actionContainer = getVisibleActionContainer(form);
    if (!preview || !actionContainer) {
      return;
    }

    if (movedPreview && movedPreview.preview !== preview) {
      restorePreview();
    }

    if (preview.parentElement === actionContainer) {
      return;
    }

    movedPreview = {
      preview,
      parent: preview.parentElement,
      nextSibling: preview.nextSibling
    };

    if (!movedPreview.parent) {
      movedPreview = null;
      return;
    }

    const submitButton = actionContainer.querySelector(PRODUCT_SUBMIT_SELECTOR);
    actionContainer.insertBefore(preview, submitButton);
  }

  function scheduleReconcile() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(reconcilePreview);
  }

  document.addEventListener("teeinblue-event-component-injected", scheduleReconcile);
  window.addEventListener("resize", scheduleReconcile, { passive: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleReconcile);
  } else {
    scheduleReconcile();
  }
})();
